import { render, staticRenderFns } from "./PurchaseCreditNotesList.vue?vue&type=template&id=5db8dc7c&"
import script from "./PurchaseCreditNotesList.vue?vue&type=script&lang=js&"
export * from "./PurchaseCreditNotesList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCreditNotesList.vue?vue&type=style&index=0&id=5db8dc7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports